// Location constants
export const ALL_LOCATIONS = 'ALL_LOCATIONS';
export const NSW = 'NSW';
export const VIC = 'VIC';

export const LOCATION_OPTIONS = [
  { key: 'All', value: ALL_LOCATIONS },
  { key: 'Melbourne', value: VIC },
  { key: 'Sydney', value: NSW },
];

// Availability constants
export const FULL_TIME_OR_PART_TIME = 'FULL_TIME_OR_PART_TIME';
export const FULL_TIME = 'FULL_TIME';
export const PART_TIME = 'PART_TIME';

export const AVAILABILITY_OPTIONS = [
  { key: 'Full-time or Part-time', value: FULL_TIME_OR_PART_TIME },
  { key: 'Full-time', value: FULL_TIME },
  { key: 'Part-time', value: PART_TIME },
];
